
import Icon from 'vux/src/components/icon/index.vue'


export default {
name: "historyRecord",
components: { Icon },
data() {
return {
imgNull: require("@/assets/image/icon/icon_null.png"),
pageType: "ebook",
pageNo: 1,
pageSize: 100,
operate: "play",
objType: "medialist",
pageData: [],
isNull: "",
title: '',
img_lazyload: require("@/assets/image/icon/img_lazyload.png")
};
},
methods: {

onClickLeft(){
this.$router.go(-1)
},
gotoDetail(id, code) {
let obj = {};
obj["path"] = this.UTILS.splitUrl("ebookGuide");
obj["params"] = { id: id, ReportUmengShare: "ebook" };

this.GLOBAL_.ccApp.openTo(obj);
},
getData() {
let postD = {
pageNo: this.pageNo,
pageSize: this.pageSize,
operate: this.operate,
objType: this.objType
};

if (this.pageType == "audioBook") {
postD["columnCodes"] = "audio,talk_book";
} else {
postD["columnCodes"] = this.pageType;
}

if (this.pageType == "ebook") {
(postD.objType = "media"), (postD.mediaType = "ebook");
}

this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.OPERATE.QUERY, postD, "GET")
.then(res => {
if (res.total > 0) {
this.pageData = res.rows;
this.isNull = false;
} else {
this.isNull = true;
}

})
.catch(err => {
this.$toast.text(this.$t('HISTORYYRECORDAUDIO_LANG.feedbackErr'));
});
},
gotoHome() {
let obj = {};
obj["path"] = "/home";
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
}
},
mounted: function() {
this.getData();
this.pageType = this.$route.query.type;
if (this.pageType == "audioBook") {
this.title = "聽過的書";
} else if (this.pageType == "ebook") {
this.title = "看過的書";
} else if (this.pageType == "course") {
this.title = "聽過的課";
}

}
};



// WEBPACK FOOTER //
// ./src/pages/me/historyRecord.vue